import { IonButton } from '@ionic/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDirectConnectGoBack } from '../helper/direct-connect-helper';
import { GateFailed, GateFailedProps } from './gate-failed';

export interface DirectConnectGateFailedProps
  extends Omit<GateFailedProps, 'rightButtons'> {}

const DirectConnectGateFailed = (props: DirectConnectGateFailedProps) => {
  const { i18n } = useTranslation();
  const goBack = useDirectConnectGoBack();

  const rightButtons = useMemo(() => {
    return <IonButton onClick={goBack}>{i18n.t('common:close')}</IonButton>;
  }, [goBack, i18n]);

  return <GateFailed {...props} rightButtons={rightButtons} />;
};

export { DirectConnectGateFailed };
